import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core";

import styles from "./styles";
import { recordTypes } from "../../../../API/config";
import EntityDocuments from "../../../EntityDocuments";
import { AttributeGroup, NoAccessScreen } from "../../../../Component";

const Financial = (props) => {
  const {
    classes,
    entity,
    hasRecordPermission,
    handleOnChange,
    handleOnUnitChange,
    listOptions,
    financialAttributes,
    reloadEntity,
  } = props;

  const { permissions = {}, confidential } = entity;

  const [maskSensitive, setMaskSensitive] = useState(false);
  const [canViewKycFields, setCanViewKycFields] = useState();
  const [canViewKycDocuments, setCanViewKycDocuments] = useState();
  const [canViewSensitiveFields, setCanViewSensitiveFields] = useState();

  useEffect(() => {
    const setPermissions = async () => {
      const canViewKycFields = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewKycFields.name,
      );
      setCanViewKycFields(canViewKycFields);

      const canViewKycDocuments = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewKycDocuments.name,
      );
      setCanViewKycDocuments(canViewKycDocuments);

      const canViewSensitiveFields = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewSensitiveFields.name,
      );
      setCanViewSensitiveFields(canViewSensitiveFields);

      if (confidential && !canViewSensitiveFields) {
        setMaskSensitive(true);
      }
    };
    setPermissions();
  }, [entity]);

  const handleChange = (attrId, newValue) => {
    handleOnChange(attrId, newValue);
  };

  const handleUnitChange = (attrId, newUnitValue) => {
    handleOnUnitChange(attrId, newUnitValue);
  };

  const renderAttributes = () => {
    return (
      <div className={classes.inputContainerStyle}>
        <AttributeGroup
          attributes={financialAttributes}
          maskSensitive={maskSensitive}
          onChange={handleChange}
          onUnitChange={handleUnitChange}
          listOptions={listOptions}
        />
      </div>
    );
  };

  if (!canViewKycFields) {
    return <NoAccessScreen />;
  }

  return (
    <div className={classes.pageContent}>
      {renderAttributes()}
      {(!confidential || canViewSensitiveFields) && canViewKycDocuments && (
        <EntityDocuments
          entity={entity}
          category="Credit"
          reloadEntity={reloadEntity}
          hasRecordPermission={hasRecordPermission}
        />
      )}
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(Financial);
